module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0095.jpg?v=93040a58";